<script setup lang="ts">
import {useModalStore} from '../../../store/modal'
import {reactive} from "vue";
import { useUserStore } from '../../../store/users';

const store = useUserStore()
const modalStore = useModalStore()
const userRoleOptions = store.roles
const userSortOptions = reactive([
    { label: 'Newest first', value: 'desc' },
    { label: 'Oldest first', value: 'asc' },
])
</script>

<template>
<div class="filters-modal-container">
    <div class="filters-modal-header">
        <button class="filters-modal-header-cross-button" @click="modalStore.close()">
            <ah-icon name="cross-default" :size="24"/>
        </button>
    </div>
    <div class="filters-modal-body">
        <div class="filters-modal-content">
            <div class="filters-modal-content-heading">
                <p>Filters.</p>
                <button>Clear</button>
            </div>

            <brand-form-select label="Role." :options="userRoleOptions" />
            <brand-form-select label="Sorting." :options="userSortOptions" />

        </div>

        <div class="filters-modal-actions">
            <brand-button>Apply</brand-button>
        </div>
    </div>
</div>
</template>

<style scoped lang="scss">

</style>
